import { Group, ActionIcon } from '@mantine/core';
import {
  IconWorld,
  IconBrandInstagram,
  IconBrandX,
  IconBrandTiktok,
} from '@tabler/icons-react';

// Small icon links for a seller's public profile extras (contract §3.5).
// Renders only the links that are set; renders nothing when none are.
const SellerSocialLinks = ({ seller, size = 'lg' }) => {
  if (!seller) return null;

  const links = [
    seller.website_url && {
      key: 'website',
      label: 'Website',
      href: seller.website_url,
      icon: <IconWorld size="1.1rem" />,
    },
    seller.instagram_handle && {
      key: 'instagram',
      label: 'Instagram',
      href: `https://instagram.com/${seller.instagram_handle}`,
      icon: <IconBrandInstagram size="1.1rem" />,
    },
    seller.twitter_handle && {
      key: 'twitter',
      label: 'Twitter / X',
      href: `https://x.com/${seller.twitter_handle}`,
      icon: <IconBrandX size="1.1rem" />,
    },
    seller.tiktok_handle && {
      key: 'tiktok',
      label: 'TikTok',
      href: `https://tiktok.com/@${seller.tiktok_handle}`,
      icon: <IconBrandTiktok size="1.1rem" />,
    },
  ].filter(Boolean);

  if (links.length === 0) return null;

  return (
    <Group gap="xs" justify="center">
      {links.map((link) => (
        <ActionIcon
          key={link.key}
          component="a"
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          variant="light"
          color="grape"
          size={size}
          radius="xl"
        >
          {link.icon}
        </ActionIcon>
      ))}
    </Group>
  );
};

export default SellerSocialLinks;
